export enum BwicStageEndType {
    Automatically = "Automatically",
    Manually = "Manually",
}
